import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';
import { Loader } from '@hivebrite/design-system/Loader';
import { Button } from '@hivebrite/design-system/Button';

import { PaymentProvider } from 'hb-react/shared/components/Payment/context/PaymentContext';
import { Gateway } from 'hb-react/shared/components/Payment/Gateway';
import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/v2';

export const PaymentPage = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useShoppingCard();

  if (isLoading) {
    return <Loader size={32} />;
  }

  const onSuccess = () => {
    navigate('../success', { replace: true });
  };

  return (
    <Box display="block">
      <Card width="100%">
        <Box font="h3-semibold">{__('Payment details')}</Box>
        <Divider mt={3} width="100%" />
        <PaymentProvider onSuccess={onSuccess} data={data}>
          <Gateway />
        </PaymentProvider>
      </Card>
      <NavBar />
    </Box>
  );
};

const NavBar = () => {
  const navigate = useNavigate();

  return (
    <Box mt={6}>
      <Button onClick={() => navigate(-1)} variant="secondary">
        {s__('Memberships|Go back to registration')}
      </Button>
    </Box>
  );
};
